// extracted by mini-css-extract-plugin
export default {"form":"_31Fy","option":"_3Zp5","selected":"_2_ha","radioInput":"LPiC","labelWrap":"_1xVc","labelText":"_1Ekl","description":"_1DRt"};